// ─── Wish List (saved gear) ────────────────────────────────────────────────────
window.GearList = {
  KEY: 'hn2-gear-list',

  get() {
    try { return JSON.parse(localStorage.getItem(this.KEY) || '[]'); }
    catch { return []; }
  },

  add(handle, variantId) {
    const vid = Number(variantId);
    if (!handle || !Number.isFinite(vid) || vid <= 0) return;
    const list = this.get();
    if (!list.find(i => i.handle === handle && i.variantId === vid)) {
      list.push({ handle, variantId: vid });
      localStorage.setItem(this.KEY, JSON.stringify(list));
    }
  },

  remove(handle, variantId) {
    const list = this.get().filter(i => !(i.handle === handle && i.variantId == variantId));
    localStorage.setItem(this.KEY, JSON.stringify(list));
  },

  has(handle, variantId) {
    return this.get().some(i => i.handle === handle && i.variantId == variantId);
  }
};

var _glWishlistApiIds = null;
var _glWishlistApiLoadFailed = false;

function glNormalizeVariantId(v) {
  if (v == null) return null;
  var s = String(v).trim();
  if (!s) return null;
  if (s.indexOf('gid://') === 0) {
    var parts = s.split('/');
    s = parts[parts.length - 1] || '';
  }
  var n = Number(s);
  return Number.isFinite(n) && n > 0 ? n : null;
}

function glWishlistApiConfigured() {
  var u = window.themeVariables && window.themeVariables.wishlistApiBaseUrl;
  return !!(u && String(u).trim());
}

function glWishlistApiEnabled() {
  return glWishlistApiConfigured() && glIsCustomerLoggedIn();
}

function glApplyWishlistVariantIdsFromResponse(data) {
  _glWishlistApiIds = new Set();
  var ids = data && data.variantIds ? data.variantIds : [];
  ids.forEach(function (v) {
    var n = glNormalizeVariantId(v);
    if (n) _glWishlistApiIds.add(n);
  });
}

function glSyncGearListItemFromApi(hv, vid) {
  if (!hv || !window.GearList) return;
  if (_glWishlistApiIds && _glWishlistApiIds.has(vid)) {
    window.GearList.add(hv.handle, hv.variantId);
  } else {
    window.GearList.remove(hv.handle, hv.variantId);
  }
}

function glFetchWishlistFromApi() {
  if (!glWishlistApiEnabled()) {
    _glWishlistApiIds = null;
    _glWishlistApiLoadFailed = false;
    return;
  }
  _glWishlistApiLoadFailed = false;
  var base = String(window.themeVariables.wishlistApiBaseUrl || '').replace(/\/$/, '');
  var cid = window.themeVariables.wishlistCustomerId;
  fetch(base + '?customerId=' + encodeURIComponent(cid), { credentials: 'omit' })
    .then(function (r) {
      if (!r.ok) throw new Error(String(r.status));
      return r.json();
    })
    .then(function (data) {
      glApplyWishlistVariantIdsFromResponse(data);
      glUpdateHearts();
    })
    .catch(function () {
      _glWishlistApiLoadFailed = true;
      _glWishlistApiIds = null;
      glUpdateHearts();
    });
}

function glResolveVariantsToEntries(ids) {
  var tv = window.themeVariables || {};
  var url = tv.storefrontGraphqlUrl;
  var token = tv.storefrontAccessToken;
  if (!url || !token || !ids.length) return Promise.resolve([]);

  var query =
    'query($ids:[ID!]!){nodes(ids:$ids){...on ProductVariant{id product{handle}}}}';
  var chunk = 48;
  var out = [];
  var i = 0;
  function nextChunk() {
    if (i >= ids.length) return Promise.resolve(out);
    var slice = ids.slice(i, i + chunk);
    i += chunk;
    var gids = slice.map(function (id) {
      return 'gid://shopify/ProductVariant/' + id;
    });
    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': token,
      },
      body: JSON.stringify({ query: query, variables: { ids: gids } }),
    })
      .then(function (r) {
        if (!r.ok) throw new Error(String(r.status));
        return r.json();
      })
      .then(function (json) {
        var nodes = (json.data && json.data.nodes) || [];
        nodes.forEach(function (node) {
          if (!node || !node.product || !node.product.handle) return;
          var vid = glNormalizeVariantId(node.id);
          if (vid) {
            out.push({ handle: node.product.handle, variantId: vid });
          }
        });
        return nextChunk();
      });
  }
  return nextChunk();
}

window.GlWishlist = {
  normalizeVariantId: glNormalizeVariantId,
  loadGearListEntries: function () {
    var tv = window.themeVariables || {};
    var base = String(tv.wishlistApiBaseUrl || '').replace(/\/$/, '');
    var cid = tv.wishlistCustomerId;
    return fetch(base + '?customerId=' + encodeURIComponent(cid), { credentials: 'omit' })
      .then(function (r) {
        if (!r.ok) throw new Error(String(r.status));
        return r.json();
      })
      .then(function (data) {
        var rawIds = (data && data.variantIds) || [];
        var ids = rawIds.map(glNormalizeVariantId).filter(Boolean);
        if (!ids.length) {
          glApplyWishlistVariantIdsFromResponse(data || { variantIds: [] });
          // Do not wipe localStorage here: server may be empty while the customer
          // still has items saved only in the browser from before API sync.
          return window.GearList ? window.GearList.get() : [];
        }
        return glResolveVariantsToEntries(ids).then(function (entries) {
          if (window.GearList && entries.length) {
            localStorage.setItem(
              window.GearList.KEY,
              JSON.stringify(
                entries.map(function (e) {
                  return { handle: e.handle, variantId: Number(e.variantId) };
                })
              )
            );
          }
          glApplyWishlistVariantIdsFromResponse(data);
          return entries;
        });
      });
  },
  removeFromApi: function (variantId) {
    var vid = glNormalizeVariantId(variantId);
    if (!vid) return Promise.resolve();
    var tv = window.themeVariables || {};
    var base = String(tv.wishlistApiBaseUrl || '').replace(/\/$/, '');
    var cid = String(tv.wishlistCustomerId || '');
    return fetch(base, {
      method: 'DELETE',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customerId: cid, variantId: String(vid) }),
      credentials: 'omit',
    })
      .then(function (r) {
        if (!r.ok) throw new Error(String(r.status));
        return r.json();
      })
      .then(function (data) {
        if (data && data.variantIds) {
          glApplyWishlistVariantIdsFromResponse(data);
          return;
        }
        return fetch(base + '?customerId=' + encodeURIComponent(cid), { credentials: 'omit' })
          .then(function (r2) {
            if (!r2.ok) throw new Error(String(r2.status));
            return r2.json();
          })
          .then(function (d2) {
            glApplyWishlistVariantIdsFromResponse(d2);
          });
      })
      .then(function () {
        glUpdateHearts();
      });
  },
  /** POST one variant (e.g. test-run); sequential calls avoid read–write races on the metafield. */
  addVariant: function (variantId) {
    var vid = glNormalizeVariantId(variantId);
    if (!vid) return Promise.reject(new Error('Invalid variant id'));
    var tv = window.themeVariables || {};
    var base = String(tv.wishlistApiBaseUrl || '').replace(/\/$/, '');
    var cid = String(tv.wishlistCustomerId || '');
    return fetch(base, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customerId: cid, variantId: String(vid) }),
      credentials: 'omit',
    })
      .then(function (r) {
        if (!r.ok) throw new Error(String(r.status));
        return r.json();
      })
      .then(function (data) {
        if (data && data.variantIds) {
          glApplyWishlistVariantIdsFromResponse(data);
          glUpdateHearts();
          return;
        }
        return fetch(base + '?customerId=' + encodeURIComponent(cid), { credentials: 'omit' })
          .then(function (r2) {
            if (!r2.ok) throw new Error(String(r2.status));
            return r2.json();
          })
          .then(function (d2) {
            glApplyWishlistVariantIdsFromResponse(d2);
            glUpdateHearts();
          });
      });
  },
  clearAll: function () {
    var tv = window.themeVariables || {};
    var base = String(tv.wishlistApiBaseUrl || '').replace(/\/$/, '');
    var cid = String(tv.wishlistCustomerId || '');
    return fetch(base, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customerId: cid, clearAll: true }),
      credentials: 'omit',
    })
      .then(function (r) {
        if (!r.ok) throw new Error(String(r.status));
        return r.json();
      })
      .then(function (data) {
        glApplyWishlistVariantIdsFromResponse(data || { variantIds: [] });
        if (window.GearList) {
          localStorage.setItem(window.GearList.KEY, '[]');
        }
        glUpdateHearts();
      });
  },
};

document.addEventListener('gl-wishlist-cleared', function () {
  glUpdateHearts();
});

function glIsVariantWishlisted(handle, variantId) {
  var vid = Number(variantId);
  if (!Number.isFinite(vid) || vid <= 0) return false;
  if (glWishlistApiEnabled() && !_glWishlistApiLoadFailed) {
    if (_glWishlistApiIds !== null) return _glWishlistApiIds.has(vid);
    return window.GearList.has(handle, String(variantId));
  }
  return window.GearList.has(handle, String(variantId));
}

function glToggleWishlistApi(btn) {
  var hv = glGetHandleVariant(btn);
  if (!hv) return;
  var vid = glNormalizeVariantId(hv.variantId);
  if (!vid) return;
  var tv = window.themeVariables || {};
  var base = String(tv.wishlistApiBaseUrl || '').replace(/\/$/, '');
  var cid = String(tv.wishlistCustomerId || '');
  var inList = _glWishlistApiIds && _glWishlistApiIds.has(vid);
  var method = inList ? 'DELETE' : 'POST';
  btn.setAttribute('aria-busy', 'true');
  fetch(base, {
    method: method,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ customerId: cid, variantId: String(vid) }),
    credentials: 'omit',
  })
    .then(function (r) {
      if (!r.ok) throw new Error(String(r.status));
      return r.json();
    })
    .then(function (data) {
      if (data && data.variantIds) {
        glApplyWishlistVariantIdsFromResponse(data);
        glSyncGearListItemFromApi(hv, vid);
        glUpdateHearts();
        return;
      }
      return fetch(base + '?customerId=' + encodeURIComponent(cid), { credentials: 'omit' })
        .then(function (r2) {
          if (!r2.ok) throw new Error(String(r2.status));
          return r2.json();
        })
        .then(function (d2) {
          glApplyWishlistVariantIdsFromResponse(d2);
          glSyncGearListItemFromApi(hv, vid);
          glUpdateHearts();
        });
    })
    .catch(function (err) {
      console.error('wishlist API', err);
    })
    .finally(function () {
      btn.removeAttribute('aria-busy');
    });
}

(function () {
  var s = document.createElement('style');
  s.textContent =
    '.gl-wishlist-btn.gl-in-list svg path:first-of-type{opacity:1!important}' +
    '#gl-wishlist-login-modal{position:fixed;inset:0;z-index:100000;display:none;align-items:center;justify-content:center;padding:1rem;background:rgba(0,0,0,0.45);}' +
    '#gl-wishlist-login-modal.gl-open{display:flex;}' +
    '#gl-wishlist-login-modal .gl-wlm-box{max-width:26rem;background:rgb(var(--background-primary));color:rgb(var(--text-primary));padding:1.5rem;border-radius:var(--rounded-sm);box-shadow:0 8px 32px rgba(0,0,0,0.2);}' +
    '#gl-wishlist-login-modal .gl-wlm-heading{display:flex;align-items:center;gap:0.5rem;margin:0 0 1rem;font-size:var(--text-h5);font-weight:600;line-height:1.25;}' +
    '#gl-wishlist-login-modal .gl-wlm-heading svg{width:1.35rem;height:1.35rem;flex-shrink:0;pointer-events:none;}' +
    '#gl-wishlist-login-modal .gl-wlm-body{margin:0 0 1rem;line-height:1.5;font-size:var(--text-sm);}' +
    '#gl-wishlist-login-modal .gl-wlm-actions{display:flex;flex-wrap:wrap;gap:0.75rem;align-items:center;justify-content:flex-end;}' +
    '#gl-wishlist-login-modal .button{flex:1 1 auto;min-width:8rem;text-align:center;}';
  document.head.appendChild(s);
})();

function glIsCustomerLoggedIn() {
  try {
    return !!(window.themeVariables && window.themeVariables.customerLoggedIn);
  } catch (e) {
    return false;
  }
}

function glEnsureWishlistLoginModal() {
  if (document.getElementById('gl-wishlist-login-modal')) return;
  var loginUrl =
    (window.themeVariables && window.themeVariables.accountLoginUrl) || '/account/login';
  var wrap = document.createElement('div');
  wrap.id = 'gl-wishlist-login-modal';
  wrap.setAttribute('role', 'dialog');
  wrap.setAttribute('aria-modal', 'true');
  wrap.setAttribute('aria-labelledby', 'gl-wishlist-login-title');
  wrap.innerHTML =
    '<div class="gl-wlm-box">' +
    '<h2 id="gl-wishlist-login-title" class="gl-wlm-heading">' +
    '<span>Wishlist and Compare</span>' +
    '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none" aria-hidden="true" focusable="false">' +
    '<path opacity="0.2" d="M29 12.5625C29 20.8125 16 27.8125 16 27.8125C16 27.8125 3 20.8125 3 12.5625C3 10.7723 3.71116 9.0554 4.97703 7.78953C6.2429 6.52366 7.95979 5.8125 9.75 5.8125C12.5737 5.8125 14.9925 7.35125 16 9.8125C17.0075 7.35125 19.4263 5.8125 22.25 5.8125C24.0402 5.8125 25.7571 6.52366 27.023 7.78953C28.2888 9.0554 29 10.7723 29 12.5625Z" fill="#628022"/>' +
    '<path d="M22.25 4.8125C19.6688 4.8125 17.4088 5.9225 16 7.79875C14.5912 5.9225 12.3313 4.8125 9.75 4.8125C7.69528 4.81482 5.72539 5.63208 4.27248 7.08498C2.81958 8.53789 2.00232 10.5078 2 12.5625C2 21.3125 14.9738 28.395 15.5262 28.6875C15.6719 28.7658 15.8346 28.8068 16 28.8068C16.1654 28.8068 16.3281 28.7658 16.4737 28.6875C17.0262 28.395 30 21.3125 30 12.5625C29.9977 10.5078 29.1804 8.53789 27.7275 7.08498C26.2746 5.63208 24.3047 4.81482 22.25 4.8125ZM16 26.6625C13.7175 25.3325 4 19.2738 4 12.5625C4.00198 11.0381 4.60842 9.57673 5.68633 8.49883C6.76423 7.42092 8.22561 6.81448 9.75 6.8125C12.1812 6.8125 14.2225 8.1075 15.075 10.1875C15.1503 10.3709 15.2785 10.5278 15.4432 10.6382C15.6079 10.7486 15.8017 10.8075 16 10.8075C16.1983 10.8075 16.3921 10.7486 16.5568 10.6382C16.7215 10.5278 16.8497 10.3709 16.925 10.1875C17.7775 8.10375 19.8188 6.8125 22.25 6.8125C23.7744 6.81448 25.2358 7.42092 26.3137 8.49883C27.3916 9.57673 27.998 11.0381 28 12.5625C28 19.2638 18.28 25.3313 16 26.6625Z" fill="#628022"/>' +
    '</svg></h2>' +
    '<p class="gl-wlm-body">You must be logged in to use the wishlist feature. We don\'t spam you in any way for the things you put in the list. It\'s just intended to be a helpful tool to keep track of what you want or compare tech specs against each other.</p>' +
    '<div class="gl-wlm-actions">' +
    '<a href="' +
    loginUrl.replace(/"/g, '&quot;') +
    '" class="button button--primary">Log In Here</a>' +
    '</div></div>';
  document.body.appendChild(wrap);
  wrap.addEventListener('click', function (e) {
    if (e.target === wrap) wrap.classList.remove('gl-open');
  });
}

function glShowWishlistLoginModal() {
  glEnsureWishlistLoginModal();
  var m = document.getElementById('gl-wishlist-login-modal');
  if (!m) return;
  m.classList.add('gl-open');
  var a = m.querySelector('a.button');
  if (a) a.focus();
}

document.addEventListener('keydown', function (e) {
  if (e.key !== 'Escape') return;
  var m = document.getElementById('gl-wishlist-login-modal');
  if (m && m.classList.contains('gl-open')) m.classList.remove('gl-open');
});

document.addEventListener(
  'click',
  function (e) {
    const link = e.target.closest && e.target.closest('[data-gl-header-wishlist]');
    if (!link) return;
    if (glIsCustomerLoggedIn()) return;
    e.preventDefault();
    glShowWishlistLoginModal();
  },
  true
);

function glGetHandleVariant(btn) {
  const card = btn.closest('product-card') || btn.closest('[handle]');

  let handle = card ? card.getAttribute('handle') : null;
  if (!handle && window.themeVariables && window.themeVariables.currentProductHandle) {
    handle = window.themeVariables.currentProductHandle;
  }
  if (!handle) return null;

  let variantId = '';
  const formRoot = btn.closest('form');
  const formInput = formRoot && formRoot.querySelector('input[name="id"]');
  const cardInput = card && card.querySelector('input[name="id"]');
  if (formInput && formInput.value) {
    variantId = formInput.value;
  } else if (cardInput && cardInput.value) {
    variantId = cardInput.value;
  } else {
    const pdpInput = document.querySelector(
      'product-info input[name="id"], .shopify-product-form input[name="id"], form[is="product-form"] input[name="id"]'
    );
    if (
      pdpInput &&
      pdpInput.value &&
      btn.closest('.product-info__buy-buttons, .buy_buttons-wishlist, product-info')
    ) {
      variantId = pdpInput.value;
    }
  }

  if (!variantId) {
    variantId =
      btn.getAttribute('data-variant-id') ||
      btn.getAttribute('data-epi') ||
      '';
  }

  if (!variantId && card) {
    const link = card.querySelector('a[href*="/products/"]');
    if (link && link.href) {
      try {
        const v = new URL(link.href, location.origin).searchParams.get('variant');
        if (v) variantId = v;
      } catch (e) {}
    }
  }

  return variantId ? { handle, variantId } : null;
}

function glWishlistControlSelector() {
  return '.gl-wishlist-btn';
}

function glUpdateHearts() {
  document.querySelectorAll(glWishlistControlSelector()).forEach(btn => {
    const hv = glGetHandleVariant(btn);
    if (!hv || !hv.variantId) return;
    const vid = Number(hv.variantId);
    if (!Number.isFinite(vid) || vid <= 0) return;
    btn.classList.toggle('gl-in-list', glIsVariantWishlisted(hv.handle, hv.variantId));
  });
}

function glToggleGearListForBtn(btn) {
  if (
    glWishlistApiEnabled() &&
    !_glWishlistApiLoadFailed &&
    _glWishlistApiIds !== null
  ) {
    glToggleWishlistApi(btn);
    return;
  }
  const run = () => {
    const hv = glGetHandleVariant(btn);
    if (!hv) return false;
    const { handle, variantId } = hv;
    const vid = Number(variantId);
    if (!Number.isFinite(vid) || vid <= 0) return false;
    if (window.GearList.has(handle, variantId)) {
      window.GearList.remove(handle, variantId);
      btn.classList.remove('gl-in-list');
    } else {
      window.GearList.add(handle, variantId);
      btn.classList.add('gl-in-list');
    }
    return true;
  };
  if (run()) return;
  setTimeout(run, 0);
}

document.addEventListener('variant:change', function () {
  glUpdateHearts();
});

document.addEventListener(
  'click',
  function (e) {
    const btn = e.target.closest && e.target.closest(glWishlistControlSelector());
    if (!btn) return;
    const hv = glGetHandleVariant(btn);
    if (!hv) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (!glIsCustomerLoggedIn()) {
      glShowWishlistLoginModal();
      return;
    }
    glToggleGearListForBtn(btn);
  },
  true
);

let _glHeartDebounce;
new MutationObserver(() => {
  clearTimeout(_glHeartDebounce);
  _glHeartDebounce = setTimeout(glUpdateHearts, 50);
}).observe(document.body, { childList: true, subtree: true });
glFetchWishlistFromApi();
glUpdateHearts();
// ─────────────────────────────────────────────────────────────────────────────

// NOTE: the Bolting+, ProDealz, and plain-sale variant:change patches that used
// to live here have been consolidated into ONE data-driven "discount-display
// guard" further down this file (search "Discount-display guard"). Keeping them
// separate let labeled price-lists fall through heuristic gates and compound.
// ─────────────────────────────────────────────────────────────────────────────

window.addEventListener('DOMContentLoaded', () => {
    let oneTime = document.querySelector('.block-swatch--custom');
    let selectedOption = document.querySelectorAll('.pdp-variant-input');
    let customBlockSwatch = document.querySelectorAll('.custom-block-swatch');
    let btns = document.querySelector('.product-info__buy-buttons');
    let variantOptionValue = document.querySelector('variant-option-value');
    let productInfoPrice  = document.querySelector('.product-info__price');
    let suppoerBenefits  = document.querySelector('.suppoer-benefits');
    let productInfoBuyButtons  = document.querySelector('.product-info__buy-buttons');
    let supportDescription  = document.querySelector('.support-description');
    let supporterIcons  = document.querySelector('.supporter-icons');

    if(oneTime) {
        oneTime.addEventListener('click', ()=>{

            oneTime.classList.add('active');
            selectedOption.forEach((item)=>{
                if(item.checked){
                    item.checked = false;
                }
                if(btns){
                    btns.classList.add('hidden')
                }
                if(variantOptionValue){
                    variantOptionValue.innerHTML = "One time donation";
                }
                if(productInfoPrice){
                    productInfoPrice.classList.add('hidden');
                }
                if(suppoerBenefits){
                    suppoerBenefits.classList.add('hidden');
                }
                if(productInfoBuyButtons){
                    productInfoBuyButtons.classList.add('hidden');
                }
                if(supportDescription){
                    supportDescription.classList.add('hidden');
                }
                if(supporterIcons){
                    supporterIcons.classList.remove('hidden');
                }
            })
        })
    }

    customBlockSwatch.forEach((item) => {
        item.addEventListener('click', () => {
            hn2Log('window.themeVariables.currentProductHandle', window.themeVariables.currentProductHandle)
            if(window.themeVariables.currentProductHandle.includes('supporter')) {
                if(oneTime) {
                    oneTime.classList.remove('active');
                }
                if(btns){
                    btns.classList.remove('hidden')
                }
                if(variantOptionValue){

                }
                if(productInfoPrice){
                    productInfoPrice.classList.remove('hidden');
                }
                if(suppoerBenefits){
                    suppoerBenefits.classList.remove('hidden');
                }
                if(productInfoBuyButtons){
                    productInfoBuyButtons.classList.remove('hidden');
                }
                if(supportDescription){
                    supportDescription.classList.remove('hidden');
                }
                if(supporterIcons){
                    supporterIcons.classList.add('hidden');
                }
            }
        })
    })

    let currPage = location.href;
    let main = document.querySelector('#main');
    let le = document.createElement('div');
    le.classList.add('membership-nav-bar')
    let mainSupporterWrap = document.querySelector('#conjured_membership');
    if(currPage.includes('/a/membership/dashboard/')) {
        if(main){
            main.prepend(le)
            le.innerHTML = '<section id="shopify-section-account-banner" class="shopify-section shopify-section--account-banner"><nav class="account-nav bg-secondary"> <div class="relative container"> <ul class="h-stack justify-center gap-8 mobile-gap-unset" role="list"><li class="account-nav__item"> <a href="/account" class="bold link-faded">Orders</a> </li> <li class="account-nav__item"><a href="/pages/my-wish-list" class="bold link-faded">My Wish List</a></li> <li class="account-nav__item" aria-current="page" > <a href="/a/membership/dashboard/" class="bold"> Membership Settings </a> </li> <li class="account-nav__item"> <a href="/account/addresses" class="bold link-faded">Addresses</a> </li> <li class="account-nav__item account-nav__item--logout"> <a href="/account/logout" class="link-faded" data-no-instant="">Logout</a> </li> </ul> </div> </nav> </section>';
        }
    }

    /* youtube-latest-static carousel */
    const ylsReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-youtube-latest-static]').forEach((root) => {
        const viewport = root.querySelector('.youtube-latest-static__viewport');
        const prev = root.querySelector('.youtube-latest-static__arrow--prev');
        const next = root.querySelector('.youtube-latest-static__arrow--next');
        const progressFill = root.querySelector('.youtube-latest-static__progress-fill');
        if (!viewport || !prev || !next) {
            return;
        }

        const getStep = () => {
            const slide = viewport.querySelector('.youtube-latest-static__slide');
            if (!slide) {
                return Math.max(360, viewport.clientWidth * 0.85);
            }
            const track = viewport.querySelector('.youtube-latest-static__track');
            let gap = 16;
            if (track) {
                const g = window.getComputedStyle(track).gap;
                const parsed = parseFloat(g);
                if (!Number.isNaN(parsed)) {
                    gap = parsed;
                }
            }
            return slide.getBoundingClientRect().width + gap;
        };

        const updateArrows = () => {
            const { scrollLeft, scrollWidth, clientWidth } = viewport;
            const maxScroll = Math.max(0, scrollWidth - clientWidth);
            const atStart = scrollLeft <= 2;
            const atEnd = scrollLeft >= maxScroll - 2;
            prev.disabled = atStart;
            next.disabled = atEnd;
            if (progressFill) {
                if (maxScroll <= 0) {
                    progressFill.style.width = '100%';
                } else {
                    const pct = (scrollLeft / maxScroll) * 100;
                    progressFill.style.width = `${Math.min(100, Math.max(0, pct))}%`;
                }
            }
        };

        const scrollByStep = (direction) => {
            viewport.scrollBy({
                left: getStep() * direction,
                behavior: ylsReducedMotion ? 'auto' : 'smooth',
            });
        };

        prev.addEventListener('click', () => scrollByStep(-1));
        next.addEventListener('click', () => scrollByStep(1));

        viewport.addEventListener(
            'scroll',
            () => window.requestAnimationFrame(updateArrows),
            { passive: true }
        );
        window.addEventListener('resize', updateArrows);

        viewport.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowLeft') {
                e.preventDefault();
                scrollByStep(-1);
            } else if (e.key === 'ArrowRight') {
                e.preventDefault();
                scrollByStep(1);
            }
        });

        updateArrows();
    });

});

// ─── Discount-display guard: kill the "infinite money" variant-spam glitch ──
// Replaces the three previous variant:change patches (Bolting+, ProDealz, and
// plain sales), which were fragmented and each gated on its own conditions, so a
// price-list could fall through every one of them and be left to theme.js.
//
// Root cause: the bundled <sale-price>/<compare-at-price> elements in theme.js
// recompute their discount from the price *text currently shown in the DOM* on
// every variant:change. Reading an already-discounted number means each variant
// click compounds the reduction — the price spirals toward $0. This bit every
// place we render a UI-only "fake" discount that mirrors a Shopify automatic
// discount applied at checkout: ProDealz, SAR, Friends & Family, AWAH B2B,
// Memorial-Day, Bolting+.
//
// Fix: in the bubble phase (after the bundled handlers run) recompute both prices
// straight from event.detail.variant + the rate the server stamped on the
// price-list, so the result is identical no matter how many times you click. The
// guard is purely data-driven — it never reads displayed text and never guesses
// from customer tags — so no labeled price-list can slip through a heuristic.
// Markers the server emits (see snippets/price-list.liquid):
//
//   data-prodealz="true" data-prodealz-rate="0.30"
//       Fixed "% off" the variant's own price, always shown (the server bases the
//       display on variant.price and ignores any real compare_at). Covers
//       ProDealz / SAR / Friends & Family / AWAH B2B / Memorial-Day.
//   data-bolting-rate="0.20"
//       Bolting+ new-bolter "% off", but suppressed (real sale shown, label
//       hidden) when the chosen variant is itself on sale.
//
// A price-list with neither marker is a plain product: we only rewrite it when
// the chosen variant is genuinely on sale, to stop the same compounding there.
// Everything is scoped to the changed form via sale-price[form="…"] so quick-buy
// drawers, recommendation cards and stacked products never bleed into each other.
(function () {
  const PRODEALZ_DEFAULT_RATE = 0.30;

  function formatMoneyCents(cents) {
    const settings = (window.themeVariables && window.themeVariables.settings) || {};
    const fmt = (settings.currencyCodeEnabled ? settings.moneyWithCurrencyFormat : settings.moneyFormat) || '${{amount}}';
    let dec = '.', thou = ',';
    if (/with_comma_separator/.test(fmt)) { dec = ','; thou = '.'; }
    else if (/with_space_separator/.test(fmt)) { dec = '.'; thou = ' '; }
    else if (/with_apostrophe_separator/.test(fmt)) { dec = '.'; thou = "'"; }
    const precision = /no_decimals/.test(fmt) ? 0 : 2;
    const parts = (Number(cents) / 100).toFixed(precision).split('.');
    const whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thou);
    const amount = parts[1] ? whole + dec + parts[1] : whole;
    return fmt.replace(/\{\{\s*amount[^}]*\s*\}\}/, amount).replace(/USD/g, '').trim();
  }

  function setPriceText(el, text) {
    if (!el) return;
    const srOnly = el.querySelector('.sr-only');
    el.innerHTML = '';
    if (srOnly) el.appendChild(srOnly);
    el.appendChild(document.createTextNode(text));
  }

  function showCompare(compareEl, cents) {
    if (!compareEl) return;
    setPriceText(compareEl, formatMoneyCents(cents));
    compareEl.hidden = false;
    compareEl.removeAttribute('hidden');
  }

  // Collect the <sale-price> elements to fix for this event. Robust to however
  // the theme dispatches variant:change — we don't assume event.target is the
  // form. Primary key is the product id, which is embedded in every price form
  // attribute ("product-form-<id>-<section>" / "quick-buy-form-<id>-<section>"),
  // so we hit exactly this product's prices (main PDP, sticky, quick-buy) and
  // never a different product on the page. Falls back to the changed form id and
  // then the surrounding product container.
  function collectSaleEls(event) {
    const out = new Set();
    const tgt = event.target;
    const pid = event.detail && event.detail.product && event.detail.product.id;
    if (pid) {
      document.querySelectorAll('sale-price[form*="-' + pid + '-"]').forEach(function (s) { out.add(s); });
    }
    var formId = (tgt && tgt.id) || (tgt && tgt.closest && tgt.closest('form') ? tgt.closest('form').id : '');
    if (formId) {
      var e = (window.CSS && CSS.escape) ? CSS.escape(formId) : formId;
      document.querySelectorAll('sale-price[form="' + e + '"]').forEach(function (s) { out.add(s); });
    }
    if (out.size === 0 && tgt && tgt.closest) {
      var c = tgt.closest('product-info, .product-info, safe-sticky, quick-buy-drawer, .product, .shopify-section');
      if (c) c.querySelectorAll('sale-price').forEach(function (s) { out.add(s); });
    }
    return out;
  }

  function rewriteForVariant(variant, event) {
    const price = Number(variant.price) || 0;
    const compareAt = Number(variant.compare_at_price) || 0;
    const onSale = compareAt > price;

    collectSaleEls(event).forEach(function (saleEl) {
      const priceList = saleEl.closest('.price-list');
      if (!priceList) return;

      const compareEl = priceList.querySelector('compare-at-price');
      const label = priceList.querySelector('.supporter-label');
      const prodealz = priceList.getAttribute('data-prodealz') === 'true';
      const prodealzRateAttr = parseFloat(priceList.getAttribute('data-prodealz-rate'));
      const boltingRate = parseFloat(priceList.getAttribute('data-bolting-rate'));

      // A genuine markdown ALWAYS wins. If the variant carries its own
      // compare_at_price we show that real sale and never stack an artificial
      // discount (ProDealz / SAR / F&F / AWAH / Memorial-Day / Bolting+) on top of it —
      // and we hide the artificial label. Checking onSale first (before the
      // markers) is also what kills the compounding: every branch now re-derives
      // the price straight from event.detail.variant, so theme.js can never leave
      // a spiralled value here regardless of stray page labels or partial payloads.
      if (onSale) {
        setPriceText(saleEl, formatMoneyCents(price));
        saleEl.classList.add('text-on-sale');
        showCompare(compareEl, compareAt);
        if (label) label.setAttribute('hidden', 'hidden');
      } else if (prodealz) {
        // ProDealz / SAR / F&F / AWAH / Memorial-Day — fixed % off the variant's price.
        const rate = isNaN(prodealzRateAttr) ? PRODEALZ_DEFAULT_RATE : prodealzRateAttr;
        setPriceText(saleEl, formatMoneyCents(Math.round(price * (1 - rate))));
        saleEl.classList.add('text-on-sale');
        showCompare(compareEl, price);
        if (label) label.removeAttribute('hidden');
      } else if (!isNaN(boltingRate)) {
        // Bolting+ new-bolter — fixed % off the variant's price.
        setPriceText(saleEl, formatMoneyCents(Math.round(price * (1 - boltingRate))));
        saleEl.classList.add('text-on-sale');
        showCompare(compareEl, price);
        if (label) label.removeAttribute('hidden');
      } else {
        // Plain product, not on sale — reset fully to the regular (black) price.
        // A previously-selected on-sale variant of this same product leaves
        // 'text-on-sale' on the sale element, the <compare-at-price> un-hidden,
        // and any label showing. If we only rewrote the text, the regular price
        // would stay red with a stale struck-through compare beside it. Strip
        // all three so switching back to a full-price variant looks correct.
        setPriceText(saleEl, formatMoneyCents(price));
        saleEl.classList.remove('text-on-sale');
        if (compareEl) {
          compareEl.setAttribute('hidden', 'hidden');
          compareEl.hidden = true;
        }
        if (label) label.setAttribute('hidden', 'hidden');
      }
    });
  }

  document.addEventListener('variant:change', function (event) {
    const variant = event.detail && event.detail.variant;
    if (!variant || variant.price == null) return;

    rewriteForVariant(variant, event);
    // Re-assert next frame in case a bundled async handler writes after us.
    requestAnimationFrame(function () { rewriteForVariant(variant, event); });
  });
})();

// ─── Base pre-order template button override ──────────────────────────────
// On product.pre-order.json the ATC must always read "Pre-Order: Add to Cart"
// (orange .btn-orange) when in stock and "Sold out" (grey) when inventory ≤ 0.
// theme.js's variant:change handler resets the label/class on every variant
// swap, so re-apply after it runs.
(function () {
  function applyPreOrderState(buyButtons) {
    const submitBtn = buyButtons.querySelector('.buy_buttons-wishlist .button[type="submit"]') || buyButtons.querySelector('.button[type="submit"]');
    if (!submitBtn) return;
    const labelEl = submitBtn.getAttribute('is') === 'custom-button'
      ? (submitBtn.firstElementChild || submitBtn)
      : submitBtn;

    const variantId = buyButtons.querySelector('input[name="id"]')?.value
      || document.querySelector('input[name="id"]')?.value;
    const variantData = variantId ? document.querySelector('.variant-data[data-id="' + variantId + '"]') : null;
    const stock = variantData ? Number(variantData.getAttribute('data-quantity')) : NaN;
    const isAvailable = variantData ? variantData.getAttribute('data-is-available') === 'true' : true;
    const inStock = isAvailable && Number.isFinite(stock) && stock > 0;

    if (inStock) {
      submitBtn.classList.add('btn-orange');
      submitBtn.classList.remove('button--subdued');
      submitBtn.disabled = false;
      submitBtn.removeAttribute('disabled');
      labelEl.innerHTML = 'Pre-Order: Add to Cart';
    } else {
      submitBtn.classList.remove('btn-orange');
      submitBtn.classList.add('button--subdued');
      submitBtn.disabled = true;
      submitBtn.setAttribute('disabled', 'disabled');
      const soldOutLabel = (window.themeVariables && window.themeVariables.strings && window.themeVariables.strings.soldOutButton) || 'Sold out';
      labelEl.innerHTML = soldOutLabel;
    }
  }

  function applyAllPreOrderState() {
    const nodes = document.querySelectorAll('buy-buttons[template="pre-order"]');
    nodes.forEach(applyPreOrderState);
  }

  document.addEventListener('variant:change', function (event) {
    const fromTarget = event.target && event.target.closest && event.target.closest('buy-buttons');
    if (fromTarget && fromTarget.getAttribute('template') === 'pre-order') {
      applyPreOrderState(fromTarget);
      requestAnimationFrame(function () { applyPreOrderState(fromTarget); });
    } else if (document.querySelector('buy-buttons[template="pre-order"]')) {
      applyAllPreOrderState();
      requestAnimationFrame(applyAllPreOrderState);
    }
  });

  document.addEventListener('DOMContentLoaded', applyAllPreOrderState);
})();

// ─── Bolting+ savings teaser: live-update the $ amount on variant change ───
// Non-bolters see a gold pill on bolting-plus-item PDPs advertising the 20%
// membership saving ("Save 20% — pay $X with Bolting+", server-rendered in
// price-list.liquid). The bundled price handlers don't know about it, so
// recompute the amount from event.detail.variant on every swap. Hide the whole
// row when the chosen variant is already on sale (compare_at_price set) — the
// 20% membership discount never stacks on an already-discounted variant,
// matching the server-side gating. Scoped to the changed form's product
// container so a quick-view drawer on a collection page can't bleed into
// another product. A small (i) button next to the pill toggles an explainer
// toast (mirrors the Sport-tag affordance); handled via delegation so multiple
// price-list instances on one page don't collide.
(function () {
  function formatMoneyCents(cents) {
    const settings = (window.themeVariables && window.themeVariables.settings) || {};
    const fmt = (settings.currencyCodeEnabled ? settings.moneyWithCurrencyFormat : settings.moneyFormat) || '${{amount}}';
    let dec = '.', thou = ',';
    if (/with_comma_separator/.test(fmt)) { dec = ','; thou = '.'; }
    else if (/with_space_separator/.test(fmt)) { dec = '.'; thou = ' '; }
    else if (/with_apostrophe_separator/.test(fmt)) { dec = '.'; thou = "'"; }
    const precision = /no_decimals/.test(fmt) ? 0 : 2;
    const parts = (Number(cents) / 100).toFixed(precision).split('.');
    const whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thou);
    const amount = parts[1] ? whole + dec + parts[1] : whole;
    return fmt.replace(/\{\{\s*amount[^}]*\s*\}\}/, amount).replace(/USD/g, '').trim();
  }

  document.addEventListener('variant:change', function (event) {
    const variant = event.detail && event.detail.variant;
    if (!variant || variant.price == null) return;

    let scope = event.target && event.target.closest
      ? event.target.closest('product-info, .product-info, safe-sticky, quick-buy-drawer, .drawer')
      : null;
    const teasers = (scope || document).querySelectorAll('[data-bolting-plus-teaser]');
    if (!teasers.length) return;

    const price = Number(variant.price) || 0;
    const onSale = Number(variant.compare_at_price) > price;

    teasers.forEach(function (teaser) {
      const row = teaser.closest('.bolting-plus-teaser-row') || teaser;
      if (onSale) {
        row.hidden = true;
        row.style.display = 'none';
        return;
      }
      row.hidden = false;
      row.style.display = '';
      const priceEl = teaser.querySelector('.bolting-plus-teaser__price');
      if (priceEl) priceEl.textContent = formatMoneyCents(Math.round(price * 0.80));
    });
  });

  // (i) explainer toast — toggle the tip next to the clicked info button.
  function closeAllTips(except) {
    document.querySelectorAll('.bolting-plus-teaser__tip').forEach(function (tip) {
      if (tip === except) return;
      tip.hidden = true;
      const grp = tip.closest('.bolting-plus-teaser-group');
      const btn = grp && grp.querySelector('[data-bolting-info-toggle]');
      if (btn) btn.setAttribute('aria-expanded', 'false');
    });
  }

  document.addEventListener('click', function (event) {
    const btn = event.target.closest && event.target.closest('[data-bolting-info-toggle]');
    if (btn) {
      event.preventDefault();
      const group = btn.closest('.bolting-plus-teaser-group');
      const tip = group && group.querySelector('.bolting-plus-teaser__tip');
      if (!tip) return;
      const willOpen = tip.hidden;
      closeAllTips(willOpen ? tip : null);
      tip.hidden = !willOpen;
      btn.setAttribute('aria-expanded', String(willOpen));
      return;
    }
    // Click outside any tip/button closes open tips.
    if (!event.target.closest('.bolting-plus-teaser__tip')) closeAllTips(null);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAllTips(null);
  });
})();

// ─── Bolting+ cart savings teaser: recompute on cart change ─────────────────
// Server renders two mutually-exclusive teasers (main-cart.liquid) for non-
// bolters: a gentle "you could save $X" message for would-be savings of $50–$99
// and a stronger "Don't over pay!" message at $99+. On AJAX cart updates the
// cart page doesn't re-run that Liquid, so recompute here: read the per-line
// data-bolting-unit-saving attributes (rendered only on eligible lines) and
// scale by the fresh /cart.js quantities, matching item.id to the line node's
// info-id (the same pairing the cart's own discount JS uses), then pick which
// tier to show. Fully decoupled — we only read /cart.js and toggle our own
// elements, never touching the cart's fragile discount logic.
(function () {
  var MIN_CENTS = 5000;    // gentle tier: show when the would-be saving exceeds $50
  var STRONG_CENTS = 9900; // strong "Don't over pay!" tier: at/above $99 (saving covers the $99 membership)
  // Store-specific IDs come from Theme settings > ID overrides via window.themeVariables
  // (snippets/js-variables.liquid).
  var ID_OVERRIDES = (window.themeVariables && window.themeVariables.idOverrides) || {};
  // $99 Annual Bolting Supporter (SKU bolting:annual-bolting-supporter). Same id
  // gates the 20% price display in snippets/price-list.liquid.
  var MEMBERSHIP_VARIANT_ID = ID_OVERRIDES.boltingAnnualVariant;
  var MEMBERSHIP_HANDLE = 'bolting';
  var MEMBERSHIP_SKU = 'bolting:annual-bolting-supporter';
  // The membership variant is requires_selling_plan, so /cart/add 422s ("Variant
  // can only be purchased with a selling plan") without one. This is the Conjured
  // "Annual Support - $99 billed every 1 year" plan; it's only a FALLBACK — the
  // live id is read from /products/bolting.js at click time so an app-side plan
  // rebuild doesn't silently break the button.
  var MEMBERSHIP_SELLING_PLAN_ID = ID_OVERRIDES.boltingSellingPlan;

  function isBolterOrProDealz() {
    var tv = window.themeVariables || {};
    var tags = Array.isArray(tv.customer_tags) ? tv.customer_tags : [];
    for (var i = 0; i < tags.length; i++) {
      var t = String(tags[i] || '');
      if (t === 'new-bolter' || t === 'ProDealz') return true;
    }
    return false;
  }

  function formatMoneyCents(cents) {
    var settings = (window.themeVariables && window.themeVariables.settings) || {};
    var fmt = (settings.currencyCodeEnabled ? settings.moneyWithCurrencyFormat : settings.moneyFormat) || '${{amount}}';
    var dec = '.', thou = ',';
    if (/with_comma_separator/.test(fmt)) { dec = ','; thou = '.'; }
    else if (/with_space_separator/.test(fmt)) { dec = '.'; thou = ' '; }
    else if (/with_apostrophe_separator/.test(fmt)) { dec = '.'; thou = "'"; }
    var precision = /no_decimals/.test(fmt) ? 0 : 2;
    var parts = (Number(cents) / 100).toFixed(precision).split('.');
    var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thou);
    var amount = parts[1] ? whole + dec + parts[1] : whole;
    return fmt.replace(/\{\{\s*amount[^}]*\s*\}\}/, amount).replace(/USD/g, '').trim();
  }

  function cssEscape(v) {
    return (window.CSS && CSS.escape) ? CSS.escape(String(v)) : String(v);
  }

  function refresh() {
    var teasers = document.querySelectorAll('[data-bolting-cart-teaser]');
    if (!teasers.length) return;
    if (isBolterOrProDealz()) {
      teasers.forEach(function (t) { t.classList.add('hide'); });
      return;
    }

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // Membership already in the cart -> nothing to upsell (mirrors the Liquid
        // suppression in main-cart.liquid, re-checked here on cart:change).
        var hasMembership = (cart.items || []).some(function (item) {
          return Number(item.variant_id) === MEMBERSHIP_VARIANT_ID;
        });
        if (hasMembership) {
          teasers.forEach(function (t) { t.classList.add('hide'); });
          return;
        }
        var total = 0;
        (cart.items || []).forEach(function (item) {
          var node = document.querySelector('[info-id="' + cssEscape(item.id) + '"][data-bolting-unit-saving]');
          if (!node) return;
          var unit = Number(node.getAttribute('data-bolting-unit-saving')) || 0;
          total += unit * (Number(item.quantity) || 0);
        });
        var formatted = formatMoneyCents(total);
        teasers.forEach(function (teaser) {
          var amtEl = teaser.querySelector('[data-bolting-cart-savings]');
          if (amtEl) amtEl.textContent = formatted;
          // Mutually exclusive tiers: strong at $99+, gentle for $50–$99.
          var show = teaser.getAttribute('data-bolting-tier') === 'strong'
            ? total >= STRONG_CENTS
            : (total > MIN_CENTS && total < STRONG_CENTS);
          teaser.classList.toggle('hide', !show);
        });
      })
      .catch(function () {});
  }

  // ── "Add Bolting+ — $99" button (data-bolting-cart-add, main-cart.liquid) ──
  // Resolve the membership line from the live product JSON (variant id + its
  // selling plan), falling back to the constants above if the fetch fails, then
  // add it and hard-reload. A reload, not a cart:change ping: the Bolting+ member
  // prices in price-list.liquid are server-rendered per page load, so the whole
  // page (line totals, PDP-style prices, this teaser) has to re-render to show
  // the 20% the shopper just unlocked.
  var membershipLinePromise = null;

  function resolveMembershipLine() {
    if (membershipLinePromise) return membershipLinePromise;
    membershipLinePromise = fetch('/products/' + MEMBERSHIP_HANDLE + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (product) {
        var variants = (product && product.variants) || [];
        var variant = null;
        for (var i = 0; i < variants.length; i++) {
          if (Number(variants[i].id) === MEMBERSHIP_VARIANT_ID || variants[i].sku === MEMBERSHIP_SKU) {
            variant = variants[i];
            break;
          }
        }
        if (!variant) return { id: MEMBERSHIP_VARIANT_ID, selling_plan: MEMBERSHIP_SELLING_PLAN_ID };
        var allocation = (variant.selling_plan_allocations || [])[0];
        return {
          id: variant.id,
          selling_plan: (allocation && allocation.selling_plan_id) || MEMBERSHIP_SELLING_PLAN_ID
        };
      })
      .catch(function () {
        return { id: MEMBERSHIP_VARIANT_ID, selling_plan: MEMBERSHIP_SELLING_PLAN_ID };
      });
    return membershipLinePromise;
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest('[data-bolting-cart-add]');
    if (!button || button.disabled) return;
    event.preventDefault();

    button.disabled = true;
    button.textContent = 'Adding…';

    resolveMembershipLine()
      .then(function (line) {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: line.id, quantity: 1, selling_plan: line.selling_plan }] })
        });
      })
      .then(function (response) {
        if (!response.ok) throw new Error('add failed');
        window.location.reload();
      })
      .catch(function () {
        // Couldn't add in place — send them to the product page rather than
        // leaving a dead button (the original loop-back-to-cart complaint).
        membershipLinePromise = null;
        button.disabled = false;
        button.textContent = button.getAttribute('data-bolting-cart-add-label') || 'Add Bolting+ — $99';
        var link = button.parentNode && button.parentNode.querySelector('.bolting-cart-teaser__btn--ghost');
        window.location.href = (link && link.getAttribute('href')) || '/products/' + MEMBERSHIP_HANDLE;
      });
  });

  document.addEventListener('cart:change', function () { requestAnimationFrame(refresh); });
  document.documentElement.addEventListener('cart:refresh', function () { requestAnimationFrame(refresh); });
  document.addEventListener('DOMContentLoaded', refresh);
})();

// ─── B2B "Place Order on Terms" gate ───────────────────────────────────────
// Remote Control, not Muscle: when a logged-in partner's cart total clears the
// threshold, hide the native checkout and show the terms UI rendered by
// snippets/terms-order-gate.liquid (present on the cart page AND in the cart
// drawer). Submitting POSTs the cart to the /apps/terms-order App Proxy, which
// signs the request and creates the unpaid order in the backend Lambda. No
// pricing/keys/Admin-API here. Lives in the global, once-loaded custom-js.js
// (not inline in the snippet) because the drawer re-renders its HTML on
// cart:change and innerHTML-injected <script> never re-runs — event delegation
// + the cart:change/cart:refresh listeners survive those re-renders.
(function () {
  if (window.HN2_TERMS_CTRL) return;
  window.HN2_TERMS_CTRL = true;

  var DEFAULT_THRESHOLD_CENTS = 500000;
  var PROXY_URL = '/apps/terms-order';

  (function injectStyle() {
    var s = document.createElement('style');
    s.textContent =
      '.hn2-checkout-hidden{display:none !important}' +
      '.hn2-terms-gate{margin-top:1rem;padding:1.25rem;border:1px solid rgb(var(--text-primary) / 0.14);border-radius:var(--rounded-sm, 10px);background:rgb(var(--background-primary, 255 255 255));}' +
      '.hn2-terms-gate[hidden]{display:none}' +
      '.hn2-terms-or{display:flex;align-items:center;gap:.75rem;margin:1rem 0 0;}' +
      '.hn2-terms-or[hidden]{display:none}' +
      '.hn2-terms-or__line{flex:1;height:1px;background:#000;}' +
      '.hn2-terms-or__text{font-size:1.5rem;font-weight:700;color:#000;}' +
      '.hn2-terms-gate .hide{display:none}' +
      '.hn2-terms-gate__field{margin:0}' +
      '.hn2-terms-gate__label{display:block;font-size:.8125rem;font-weight:600;letter-spacing:.01em;margin-bottom:.4rem;color:rgb(var(--text-primary));}' +
      '.hn2-terms-gate__optional{font-weight:400;color:rgb(var(--text-primary) / 0.55);}' +
      '.hn2-terms-gate__select{position:relative;}' +
      '.hn2-terms-gate__select-input{appearance:none;-webkit-appearance:none;-moz-appearance:none;width:100%;height:3rem;padding:0 2.75rem 0 .9rem;margin:0;font:inherit;font-size:.95rem;color:rgb(var(--text-primary));background:rgb(var(--background-primary, 255 255 255));border:1px solid rgb(var(--text-primary) / 0.25);border-radius:var(--rounded-sm, 8px);cursor:pointer;}' +
      '.hn2-terms-gate__select-input:focus{outline:none;border-color:rgb(var(--text-primary) / 0.65);box-shadow:0 0 0 3px rgb(var(--text-primary) / 0.1);}' +
      '.hn2-terms-gate__select-input:disabled{opacity:.75;cursor:default;}' +
      '.hn2-terms-gate__chevron{position:absolute;right:1rem;top:50%;width:.8rem;height:.8rem;margin-top:-.4rem;pointer-events:none;color:rgb(var(--text-primary) / 0.7);}' +
      '.hn2-terms-gate__textarea,.hn2-terms-gate__input{display:block;width:100%;padding:.7rem .9rem;margin:0;font:inherit;font-size:.95rem;line-height:1.4;color:rgb(var(--text-primary));background:rgb(var(--background-primary, 255 255 255));border:1px solid rgb(var(--text-primary) / 0.25);border-radius:var(--rounded-sm, 8px);}' +
      '.hn2-terms-gate__textarea{resize:vertical;}' +
      '.hn2-terms-gate__textarea:focus,.hn2-terms-gate__input:focus{outline:none;border-color:rgb(var(--text-primary) / 0.65);box-shadow:0 0 0 3px rgb(var(--text-primary) / 0.1);}' +
      '.hn2-terms-gate__error{color:rgb(var(--error-text, 217 48 37));margin-top:.1rem;}' +
      '.hn2-terms-gate__spinner{display:inline-block;width:1em;height:1em;margin-right:.5em;vertical-align:-.15em;border:2px solid currentColor;border-right-color:transparent;border-radius:50%;animation:hn2-terms-spin .6s linear infinite;}' +
      '@keyframes hn2-terms-spin{to{transform:rotate(360deg)}}' +
      '.hn2-terms-gate--busy [data-hn2-form]{opacity:.85;}' +
      '.hn2-terms-gate--busy [data-hn2-location],.hn2-terms-gate--busy [data-hn2-note],.hn2-terms-gate--busy [data-hn2-attn]{pointer-events:none;}';
    document.head.appendChild(s);
  })();

  function isLoggedIn() {
    if (typeof window.HN2_LOGGED_IN === 'boolean') return window.HN2_LOGGED_IN;
    return !!(window.themeVariables && window.themeVariables.customerLoggedIn);
  }

  function getTags() {
    if (Array.isArray(window.HN2_CUSTOMER_TAGS)) return window.HN2_CUSTOMER_TAGS;
    var tv = window.themeVariables || {};
    if (Array.isArray(tv.customer_tags)) return tv.customer_tags;
    return [];
  }

  // Reads config from the gate root's data-attributes (set by the snippet from
  // in-repo defaults / shop-metafield overrides).
  function readConfig(root) {
    var partnerTags = ['B2B'];
    try {
      var parsed = JSON.parse(root.getAttribute('data-partner-tags') || '["B2B"]');
      if (Array.isArray(parsed) && parsed.length) partnerTags = parsed;
    } catch (e) {}
    var threshold = parseInt(root.getAttribute('data-threshold-cents'), 10);
    return {
      partnerTags: partnerTags,
      threshold: isFinite(threshold) && threshold > 0 ? threshold : DEFAULT_THRESHOLD_CENTS,
      proxyUrl: root.getAttribute('data-proxy-url') || PROXY_URL
    };
  }

  // Partner check. The server-side flag (data-is-partner) is now computed from the B2B TAG only —
  // NOT customer.b2b?/company membership, which false-positived non-wholesale company accounts (e.g.
  // Bolting+ members) into the terms checkout. Prefer that server flag; the JS tag intersection below
  // is a fallback. Caveat: if a real B2B partner's storefront customer.tags ever resolves empty (the
  // company-contact session gotcha) BOTH signals miss and they'd see native checkout until re-auth.
  function isPartner(cfg, root) {
    if (root && root.getAttribute('data-is-partner') === 'true') return true;
    if (!isLoggedIn()) return false;
    var tags = getTags();
    for (var i = 0; i < cfg.partnerTags.length; i++) {
      if (tags.indexOf(cfg.partnerTags[i]) !== -1) return true;
    }
    return false;
  }

  function gateRoots() {
    return document.querySelectorAll('[data-hn2-terms-gate]');
  }

  function showError(root, text) {
    var el = root.querySelector('[data-hn2-error]');
    if (el) { el.textContent = text; el.classList.remove('hide'); }
  }
  function hideError(root) {
    var el = root.querySelector('[data-hn2-error]');
    if (el) { el.textContent = ''; el.classList.add('hide'); }
  }

  function updateSubmitEnabled(root) {
    var sel = root.querySelector('[data-hn2-location]');
    var btn = root.querySelector('[data-hn2-submit]');
    if (!btn) return;
    var termsSel = root.querySelector('[data-hn2-terms]');
    var termsOk = !termsSel || !!termsSel.value; // none rendered = ok; single(disabled) has a value; multi must be chosen
    btn.disabled = !(sel && sel.value && termsOk);
  }

  // Two independent signals, both driven by the same cart across the page + drawer gates:
  //   showGate    → reveal the "Place B2B Order" terms form. True for ANY partner cart with
  //                 items, regardless of total, so terms are always an available option.
  //   forceTerms  → hide native checkout (card button + accelerated buttons + card-icon row).
  //                 True for ANY partner cart with items: partners always check out through our
  //                 B2B flow, never Shopify's native checkout, at every cart total.
  function applyGated(showGate, forceTerms) {
    document.querySelectorAll('[name="checkout"]').forEach(function (btn) {
      btn.classList.toggle('hn2-checkout-hidden', forceTerms);
    });
    document.querySelectorAll('.additional-checkout-buttons').forEach(function (el) {
      el.classList.toggle('hn2-checkout-hidden', forceTerms);
    });
    // Hide the "We accept [card icons]" row only when forcing terms — above the threshold the
    // order is steered to terms-based payment, so showing card brands there only confuses.
    document.querySelectorAll('[data-hn2-payment-icons]').forEach(function (el) {
      el.classList.toggle('hn2-checkout-hidden', forceTerms);
    });
    gateRoots().forEach(function (root) {
      if (root.getAttribute('data-hn2-submitted') === 'true') return; // keep thank-you state
      root.hidden = !showGate;
      if (showGate) updateSubmitEnabled(root);
    });
    // "or" divider: only when both checkout paths are visible (gate shown AND native
    // checkout not force-hidden). Above the threshold terms is forced → no "or".
    document.querySelectorAll('[data-hn2-terms-or]').forEach(function (el) {
      el.hidden = !showGate || forceTerms;
    });
  }

  var evalTimer;
  function evaluate() {
    clearTimeout(evalTimer);
    evalTimer = setTimeout(evaluateNow, 60);
  }

  function evaluateNow() {
    if (window.HN2_TERMS_DONE) return;
    var gates = gateRoots();
    if (!gates.length) return; // not logged in / snippet not rendered → nothing to do
    var cfg = readConfig(gates[0]);
    if (!isPartner(cfg, gates[0])) { applyGated(false, false); return; }
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var hasItems = !!(cart && cart.item_count > 0);
        // Partners ALWAYS check out through our B2B flow — the native Shopify checkout is never an
        // option for them, at any cart total. So for any partner cart with items we both show the
        // terms form (showGate) and force terms (hide native checkout + accelerated buttons + card
        // icons). The threshold is retained in config for reference/future tuning but no longer
        // gates forcing — reaching this code already means the customer is a partner.
        var forceTerms = hasItems;
        applyGated(hasItems, forceTerms);
      })
      .catch(function () { /* fail open: leave native checkout usable if /cart.js errors */ });
  }

  function renderSuccess(root, title, msg, url, kind) {
    root.setAttribute('data-hn2-submitted', 'true');
    root.setAttribute('data-hn2-inflight', 'false');
    root.classList.remove('hn2-terms-gate--busy');
    root.hidden = false;
    var form = root.querySelector('[data-hn2-form]');
    var success = root.querySelector('[data-hn2-success]');
    if (form) form.classList.add('hide');
    if (!success) return;
    var t = success.querySelector('[data-hn2-success-title]');
    var m = success.querySelector('[data-hn2-success-msg]');
    var link = success.querySelector('[data-hn2-success-link]');
    if (t) t.textContent = title;
    if (m) m.textContent = msg;
    if (link) {
      if (url) { link.href = url; link.hidden = false; }
      else if (kind !== 'draft') { link.href = '/account'; link.hidden = false; }
      else { link.hidden = true; }
    }
    success.classList.remove('hide');
  }

  function onTermsSuccess(data, termsLabel) {
    window.HN2_TERMS_DONE = true; // freeze the evaluator so the thank-you state isn't flipped back
    var name = data.name || '';
    var title, msg;
    if (data.kind === 'draft') {
      title = 'Request ' + name + ' submitted';
      msg = "We'll confirm shipping and send your invoice.";
    } else {
      title = 'Order ' + name + ' placed on terms';
      msg = 'Thank you! Your order has been placed.';
    }
    if (termsLabel) msg = termsLabel + ' — ' + msg; // optional echo of the chosen payment terms
    gateRoots().forEach(function (root) { renderSuccess(root, title, msg, data.url, data.kind); });
    // Clear the cart in the background. Do NOT dispatch cart:change/refresh — the
    // theme would re-render the cart section and wipe this thank-you message.
    fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } }).catch(function () {});
    // Confirmed success → retire the nonce so the next order gets a fresh one. On failure we
    // deliberately keep it, so a retry reuses the same key and the Lambda dedupes the duplicate.
    retireSubmissionNonce();
    var first = gateRoots()[0];
    if (first) { try { first.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {} }
  }

  // Idempotency nonce: one durable key per submission ATTEMPT. It survives reloads (sessionStorage)
  // and is reused verbatim across retries, so the Lambda can dedupe and never create a second order
  // from the same attempt. Sent in the POST body (NOT cart.token, which rotates/clears on /cart/clear.js).
  // Retired only on a confirmed success → the next order gets a fresh nonce.
  function getSubmissionNonce() {
    var n = sessionStorage.getItem('b2bTermsNonce');
    if (!n) {
      n = (window.crypto && crypto.randomUUID)
        ? crypto.randomUUID()
        : 'n-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2);
      sessionStorage.setItem('b2bTermsNonce', n);
    }
    return n;
  }
  function retireSubmissionNonce() {
    sessionStorage.removeItem('b2bTermsNonce');
  }

  function submitTerms(root, btn) {
    if (root.getAttribute('data-hn2-inflight') === 'true') return; // double-submit guard
    var cfg = readConfig(root);
    var sel = root.querySelector('[data-hn2-location]');
    if (!sel || !sel.value) { showError(root, 'Please choose a location to ship to.'); return; }

    // Payment terms (derived server-side from terms-* tags). Absent dropdown → 'prepay' (Lambda's default).
    var termsSel = root.querySelector('[data-hn2-terms]');
    if (termsSel && !termsSel.value) { showError(root, 'Please choose your payment terms.'); return; }
    var termsChoice = (termsSel && termsSel.value) ? termsSel.value : 'prepay';
    var termsLabel = (termsSel && termsSel.options[termsSel.selectedIndex]) ? termsSel.options[termsSel.selectedIndex].textContent.trim() : '';

    root.setAttribute('data-hn2-inflight', 'true');
    if (!btn.getAttribute('data-hn2-label')) btn.setAttribute('data-hn2-label', btn.innerHTML);
    btn.innerHTML = '<span class="hn2-terms-gate__spinner" aria-hidden="true"></span>Placing order…';
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    root.classList.add('hn2-terms-gate--busy');
    hideError(root);

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var opt = sel.options[sel.selectedIndex];
        var noteEl = root.querySelector('[data-hn2-note]');
        var attnEl = root.querySelector('[data-hn2-attn]');
        var poEl = root.querySelector('[data-hn2-po]');
        var items = (cart.items || []).map(function (i) {
          return { id: i.variant_id, quantity: i.quantity };
        });
        if (!items.length) throw new Error('Your cart is empty.');
        // Contract expected by the Store-B2B_TermsOrders Lambda (behind /apps/terms-order):
        //   { items: [{ id, quantity }], locationChoice, note?, attn? }
        // locationChoice = the visible company-location name/label (the Lambda matches on name);
        // locationId = the Shopify company-location id, sent alongside so the Lambda can key on
        // either name or id without a theme change.
        var payload = {
          items: items,
          locationChoice: opt ? opt.textContent.trim() : sel.value,
          locationId: sel.value,
          note: (noteEl && noteEl.value.trim()) ? noteEl.value.trim() : undefined,
          attn: (attnEl && attnEl.value.trim()) ? attnEl.value.trim() : undefined,
          poNumber: (poEl && poEl.value.trim()) ? poEl.value.trim() : undefined,
          termsChoice: termsChoice,
          nonce: getSubmissionNonce()
        };
        return fetch(cfg.proxyUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        });
      })
      .then(function (res) {
        // Read the JSON body even on a non-2xx so the Lambda's own error text surfaces.
        return res.json().catch(function () { return null; }).then(function (data) {
          return { httpOk: res.ok, status: res.status, data: data };
        });
      })
      .then(function (res) {
        if (!res.httpOk || !res.data || !res.data.ok) {
          throw new Error((res.data && res.data.error) || ('HTTP ' + res.status));
        }
        onTermsSuccess(res.data, termsLabel);
      })
      .catch(function (err) {
        // Anti-Wipe: the cart was never touched. Re-enable the button as a Retry.
        root.setAttribute('data-hn2-inflight', 'false');
        root.classList.remove('hn2-terms-gate--busy');
        if (btn.getAttribute('data-hn2-label')) btn.innerHTML = btn.getAttribute('data-hn2-label');
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        var detail = (err && err.message) ? err.message : '';
        showError(root, 'Couldn’t place your order' + (detail ? ' — ' + detail : '') + '. Your cart is safe — please try again.');
        if (window.console) console.error('terms-order', err);
      });
  }

  // Delegated so it survives drawer re-renders and covers both gate instances.
  document.addEventListener('change', function (e) {
    var ctrl = e.target.closest && e.target.closest('[data-hn2-location], [data-hn2-terms]');
    if (!ctrl) return;
    var root = ctrl.closest('[data-hn2-terms-gate]');
    if (root) updateSubmitEnabled(root);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-hn2-submit]');
    if (!btn) return;
    e.preventDefault();
    var root = btn.closest('[data-hn2-terms-gate]');
    if (root) submitTerms(root, btn);
  });

  document.addEventListener('cart:change', evaluate);
  document.addEventListener('cart:refresh', evaluate);
  document.addEventListener('DOMContentLoaded', evaluate);
  evaluate(); // module scripts are deferred, so the DOM is already parsed here
})();

// ─── HN2_LOYALTY_POINTS — points balance on the header loyalty icon ────────────
//
// Fills the bubble on the header token icon (a[data-loyalty-link] in sections/header.liquid) with the customer's
// available Appstle Loyalty points.
//
// SOURCE: the Appstle Loyalty app embed inlines `window._ALConfig` into every storefront page, and for a logged-in
// customer that object carries `customerId` + `customerLoyalty.availablePoints`. This is the same field Appstle's
// own cart widget reads, so we're using their public-on-the-page data, not a private API. No network call.
//
// FRESHNESS: `_ALConfig` is rendered server-side per page load, so the number is accurate as of the current page.
// If a customer redeems points inside the Appstle popup without navigating, the header stays stale until the next
// page load — the widget keeps its updated balance in its own iframe and never writes back to `_ALConfig`. The
// only live refresh would be Appstle's token-authed proxy API (/apps/loyalty/cp/api/...), which needs the app's
// own auth token out of localStorage; deliberately not doing that.
//
// FRAGILE COUPLING: if Appstle renames `_ALConfig` or `customerLoyalty.availablePoints`, the bubble simply never
// appears — the icon and its link keep working. Fails silent, never throws.
(function () {
  var CACHE_KEY = 'hn2-loyalty-points'; // { id, points } — paints instantly on the next page, before _ALConfig parses
  var POLL_MS = 150;
  var POLL_LIMIT = 40; // ~6s, in case the app embed script runs after this module

  function els() {
    var link = document.querySelector('a[data-loyalty-link]');
    if (!link) return null;
    return {
      link: link,
      wrapper: link.querySelector('[data-loyalty-count-wrapper]'),
      count: link.querySelector('[data-loyalty-count]'),
      label: link.querySelector('[data-loyalty-label]')
    };
  }

  // 940 -> "940", 1250 -> "1.2k", 12500 -> "13k". Keeps a four-digit balance from stretching the icon row.
  function format(points) {
    if (points < 1000) return String(points);
    if (points < 10000) return (Math.round(points / 100) / 10).toString().replace(/\.0$/, '') + 'k';
    return Math.round(points / 1000) + 'k';
  }

  function readConfig() {
    var cfg = window._ALConfig;
    if (!cfg || !cfg.customerId) return null; // logged out, or the embed hasn't run yet
    var raw = cfg.customerLoyalty && cfg.customerLoyalty.availablePoints;
    var points = Math.floor(Number(raw));
    return {
      id: String(cfg.customerId),
      points: Number.isFinite(points) && points > 0 ? points : 0
    };
  }

  function paint(points) {
    var el = els();
    if (!el || !el.wrapper || !el.count) return;

    if (!(points > 0)) {
      el.wrapper.hidden = true;
      el.count.textContent = '';
      if (el.label) el.label.textContent = 'Loyalty points';
      return;
    }

    el.count.textContent = format(points);
    el.wrapper.hidden = false;
    // Screen readers get the exact number; the bubble itself is aria-hidden so it isn't read twice.
    if (el.label) el.label.textContent = 'Loyalty points: ' + points.toLocaleString();
  }

  function cacheRead() {
    try { return JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null'); } catch (e) { return null; }
  }

  function cacheWrite(state) {
    try {
      if (state) sessionStorage.setItem(CACHE_KEY, JSON.stringify(state));
      else sessionStorage.removeItem(CACHE_KEY);
    } catch (e) { /* private mode — the bubble just won't pre-paint */ }
  }

  function run() {
    if (!els()) return; // B2B customers and non-modern layouts never render the link

    // Server-rendered truth about the session — skips the poll entirely for logged-out visitors, and clears a
    // balance left behind by whoever was logged in before.
    if (window.themeVariables && window.themeVariables.customerLoggedIn === false) {
      cacheWrite(null);
      paint(0);
      return;
    }

    var cached = cacheRead();
    var tries = 0;

    // Paint the cached value first so the bubble doesn't pop in late, then reconcile with _ALConfig below.
    if (cached && cached.points > 0) paint(cached.points);

    (function poll() {
      var state = readConfig();

      if (state) {
        // A different customer (or the same one with a new balance) supersedes anything cached.
        if (!cached || cached.id !== state.id || cached.points !== state.points) paint(state.points);
        cacheWrite(state);
        return;
      }

      if (++tries >= POLL_LIMIT) {
        // _ALConfig never showed up with a customer: logged out, loyalty embed off, or the app changed its shape.
        // Either way the cached number can't be trusted any more.
        if (!window._ALConfig || !window._ALConfig.customerId) {
          cacheWrite(null);
          paint(0);
        }
        return;
      }

      setTimeout(poll, POLL_MS);
    })();
  }

  run();
  // bfcache restores (back button) re-run the module's DOM, but not this IIFE — re-read on show.
  window.addEventListener('pageshow', function (e) { if (e.persisted) run(); });
})();
